export const getRegistrationInfoStart = () => ({
	type: "REGINFO_START",
});

export const getRegistrationInfoSuccess = (registrationInfo) => ({
	type: "REGINFO_SUCCESS",
	payload: registrationInfo
});

export const getRegistrationInfoFail = () => ({
	type: "REGINFO_FAIL",
});

export const registrationStart = () => ({
	type: "REGSTRATION_START",
});

export const registrationSuccess = () => ({
	type: "REGSTRATION_SUCCESS",
});

export const registrationFail = () => ({
	type: "REGSTRATION_FAIL",
});